/* ============================================
   COMFORTH DRAWER CART: Kaching enhancement (theme-hosted)
   Ported from Intelligems v10.

   Fixes in this revision:
   - Flicker: MutationObserver is paused while we write (disconnect/observe),
     observes childList only (no attribute storm), and every helper is
     write-only-if-changed. Steady state performs zero DOM writes.
   - Live theme-editor reactivity: config is re-read from the JSON script on
     every pass and on shopify:section/block events, so hiding/editing/adding
     a trust badge or changing the gift updates immediately.
   - Gift priority: the SELECTED theme-setting product wins. The live cart
     item (e.g. Kaching's generic "Hemmelig gave" mystery line) is used only
     as a fallback when no product is selected.
   - Trust badges: support a custom uploaded image or pasted SVG/file URL,
     falling back to a preset icon.
   ============================================ */

(function () {
  'use strict';

  if (window.__cfKCartInit) return;   // guard against double init on section re-render
  window.__cfKCartInit = true;

  var DEBUG = false;
  function log() {
    if (!DEBUG) return;
    var args = ['[CF KCART]'];
    for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
    console.log.apply(console, args);
  }

  /* --- TRUST ICON LIBRARY (matches theme-editor select options) --- */
  var ICONS = {
    return: '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>',
    shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="M9 12l2 2 4-4"></path>',
    headset: '<path d="M4 14v-2a8 8 0 0 1 16 0v2"></path><path d="M4 14a2 2 0 0 0 2 2h1v-6H6a2 2 0 0 0-2 2v2z"></path><path d="M20 14a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 2v2z"></path><path d="M13 20h2a5 5 0 0 0 5-5"></path>',
    truck: '<rect x="1" y="6" width="13" height="11" rx="1"></rect><path d="M14 9h4l3 3v5h-7z"></path><circle cx="6" cy="18" r="1.6"></circle><circle cx="17" cy="18" r="1.6"></circle>',
    leaf: '<path d="M11 20A7 7 0 0 1 4 13c0-5 4-9 16-9 0 8-4 13-9 16z"></path><path d="M4 20c4-6 8-9 13-10"></path>',
    lock: '<rect x="4" y="11" width="16" height="9" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path>',
    star: '<polygon points="12 2 15 9 22 9.5 17 14 18.5 21 12 17.5 5.5 21 7 14 2 9.5 9 9"></polygon>',
    heart: '<path d="M20.8 7.6a5 5 0 0 0-8.8-2.2A5 5 0 0 0 3.2 7.6c0 4 4.8 7.4 8.8 10.4 4-3 8.8-6.4 8.8-10.4z"></path>'
  };

  /* --- HELPERS --- */

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatDKK(amount) {
    amount = Number(amount) || 0;
    var parts = amount.toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return whole + ',' + parts[1];
  }

  function cleanSavingsAmount(text) {
    if (!text) return text;
    return String(text)
      .replace(/^\s*[-−–—]\s*/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* --- CONFIG (re-read so theme-editor edits & section re-renders propagate) --- */
  var GIFT_THRESHOLD = 1000;
  var GIFT_SETTING = { configured: false };
  var CART_TITLE = 'DIN INDKØBSKURV';
  var FOOTER_SAVINGS_LABEL = 'Total besparelse';
  var SHIPPING_TEXT = 'Gratis forsendelse';
  var SHIPPING_SUBTEXT = '· 1-3 hverdage';
  var GIFT_PROGRESS_TEXT = 'Køb for [amount] DKK mere og få gratis [gift]!';
  var GIFT_UNLOCKED_HEADING = 'Gratis gave tilføjet!';
  var MYSTERY_MODE = false;
  var MYSTERY_LABEL = 'Hemmelig gave';
  var MYSTERY_IMAGE = '';
  var TRUST_BADGES = [];
  var BADGE_VERSION = 't-0';
  var lastCfgRaw = null;

  function badgeKey() {
    return 't-' + TRUST_BADGES.map(function (b) {
      return (b.icon || '') + '~' + (b.text || '') + '~' + (b.image || '');
    }).join('|');
  }

  function refreshConfig() {
    var els = document.querySelectorAll('#cf-cart-config');
    if (!els.length) return;
    var el = els[els.length - 1];      // last wins after a section re-render
    var raw = el.textContent || '';
    if (raw === lastCfgRaw) return;    // unchanged, skip
    lastCfgRaw = raw;
    var c;
    try { c = JSON.parse(raw); } catch (e) { return; }
    if (c.giftThreshold != null) GIFT_THRESHOLD = Number(c.giftThreshold) || 1000;
    GIFT_SETTING = c.gift || { configured: false };
    if (c.cartTitle) CART_TITLE = c.cartTitle;
    if (c.footerSavingsLabel) FOOTER_SAVINGS_LABEL = c.footerSavingsLabel;
    if (c.shippingText) SHIPPING_TEXT = c.shippingText;
    if (c.shippingSubtext != null) SHIPPING_SUBTEXT = c.shippingSubtext;
    if (c.giftProgressText) GIFT_PROGRESS_TEXT = c.giftProgressText;
    if (c.giftUnlockedHeading) GIFT_UNLOCKED_HEADING = c.giftUnlockedHeading;
    MYSTERY_MODE = !!c.mysteryMode;
    if (c.mysteryLabel) MYSTERY_LABEL = c.mysteryLabel;
    MYSTERY_IMAGE = c.mysteryImage || '';
    TRUST_BADGES = Array.isArray(c.trustBadges) ? c.trustBadges : [];
    BADGE_VERSION = badgeKey();
  }

  /* --- STATE --- */
  var cachedCartTotal = -1;   // DKK; -1 = unknown
  var cachedItemCount = 0;
  var cachedGift = null;      // live cart gift line item, if present
  var refreshInterval = null;
  var observer = null;
  var OBS_OPTS = { childList: true, subtree: true };

  /* Run DOM writes with the observer paused so our own mutations
     never re-trigger the observer (the root cause of flicker). */
  function mutate(fn) {
    if (observer) observer.disconnect();
    try { fn(); } finally {
      if (observer) observer.observe(document.body, OBS_OPTS);
    }
  }

  /* --- CART DATA --- */

  function findGiftItem(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isGiftLine(it)) {
        return {
          title: it.product_title || it.title || '',
          image: it.image || it.featured_image || '',
          price: it.original_line_price ? formatDKK(it.original_line_price / 100) : (GIFT_SETTING.price || '')
        };
      }
    }
    return null;
  }

  function isGiftLine(it) {
    var handle = it.handle || '';
    var isFree = it.final_line_price === 0 && it.original_line_price > 0;
    var handleMatch = /gratis-gave|hemmelig|mystery/i.test(handle) ||
                      (GIFT_SETTING && GIFT_SETTING.handle && handle === GIFT_SETTING.handle);
    return isFree || handleMatch;
  }

  function fetchCartTotal(callback) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cachedCartTotal = (cart.total_price || 0) / 100;
        cachedGift = findGiftItem(cart);
        // Count paid items only. Kaching keeps the free gift as a line item
        // even when the cart is otherwise empty, so item_count would read 1.
        var n = 0;
        (cart.items || []).forEach(function (it) { if (!isGiftLine(it)) n += it.quantity || 0; });
        cachedItemCount = n;
        if (typeof callback === 'function') callback(cachedCartTotal, cachedItemCount, cart);
      })
      .catch(function () {
        if (typeof callback === 'function') callback(cachedCartTotal, cachedItemCount, null);
      });
  }

  function cleanupLegacyElements() {
    document.querySelectorAll('#cf-timer-bar, .cf-timer-bar, .cf-total-savings')
      .forEach(function (el) { el.remove(); });
  }

  /* --- INCENTIVE BAR + FREE GIFT --- */

  /* Selected theme-setting product wins; live cart gift is only a fallback.
     Mystery mode masks the name + image but keeps the value (price). */
  function giftDisplay() {
    var base;
    if (GIFT_SETTING && GIFT_SETTING.configured && GIFT_SETTING.title) {
      base = { title: GIFT_SETTING.title, image: GIFT_SETTING.image || '', price: GIFT_SETTING.price || '' };
    } else if (cachedGift && cachedGift.title) {
      base = cachedGift;
    } else {
      base = { title: '', image: '', price: '' };
    }
    if (MYSTERY_MODE && (base.title || cachedGift)) {
      return { title: MYSTERY_LABEL, image: MYSTERY_IMAGE || base.image, price: base.price };
    }
    return base;
  }

  function buildIncentiveHTML(cartTotal) {
    cartTotal = Number(cartTotal) || 0;
    var gift = giftDisplay();
    var hasGift = !!gift.title;
    // Unlock is decided by the threshold only. Kaching can leave the gift
    // line item in the cart after the subtotal drops back below the
    // threshold, so we must not treat a lingering gift line as "unlocked"
    // or the progress bar would never return.
    var isUnlocked = cartTotal >= GIFT_THRESHOLD;
    var progress = Math.min((cartTotal / GIFT_THRESHOLD) * 100, 100);
    var remaining = Math.max(GIFT_THRESHOLD - cartTotal, 0);
    var giftHTML = '';

    if (hasGift && isUnlocked) {
      giftHTML =
        '<div class="cf-gift-unlocked">' +
          '<div class="cf-gift-unlocked-img">' +
            (gift.image ? '<img src="' + escapeHtml(gift.image) + '" alt="' + escapeHtml(gift.title) + '">' : '') +
            '<div class="cf-gift-unlocked-badge" aria-hidden="true">' +
              '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
            '</div>' +
          '</div>' +
          '<div class="cf-gift-unlocked-info">' +
            '<h4>' + escapeHtml(GIFT_UNLOCKED_HEADING) + '</h4>' +
            '<p>' + escapeHtml(gift.title) + '</p>' +
            (gift.price ?
              '<div class="cf-gift-pricing"><span class="cf-free-tag">GRATIS</span>' +
              '<span class="cf-was-price">' + escapeHtml(gift.price) + ' DKK</span></div>' : '') +
          '</div>' +
        '</div>';
    } else if (hasGift) {
      var copy = escapeHtml(GIFT_PROGRESS_TEXT)
        .replace('[amount]', '<strong>' + formatDKK(remaining) + '</strong>')
        .replace('[gift]', '<strong>' + escapeHtml(gift.title) + '</strong>');
      giftHTML =
        '<div class="cf-gift-progress">' +
          (gift.image ? '<div class="cf-gift-img"><img src="' + escapeHtml(gift.image) + '" alt="' + escapeHtml(gift.title) + '"></div>' : '') +
          '<div class="cf-gift-progress-info">' +
            '<p>' + copy + '</p>' +
            '<div class="cf-progress-track" role="progressbar" aria-label="Fremskridt mod gratis gave" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(progress) + '">' +
              '<div class="cf-progress-fill" style="width:' + progress + '%;"></div>' +
            '</div>' +
            '<p class="cf-remaining">' + formatDKK(cartTotal) + ' / ' + formatDKK(GIFT_THRESHOLD) + ' DKK</p>' +
          '</div>' +
        '</div>';
    }

    return '<div class="cf-shipping-row">' +
        '<div class="cf-check-circle" aria-hidden="true">' +
          '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
        '</div>' +
        '<p>' + escapeHtml(SHIPPING_TEXT) + ' <span>' + escapeHtml(SHIPPING_SUBTEXT) + '</span></p>' +
      '</div>' + giftHTML;
  }

  function createIncentiveBar(cartTotal) {
    var bar = document.createElement('div');
    bar.className = 'cf-incentive-bar';
    bar.id = 'cf-incentive-bar';
    bar.innerHTML = buildIncentiveHTML(cartTotal);
    return bar;
  }

  /* Update the bar in place only when its content actually changed. */
  function refreshIncentiveBar(cartTotal) {
    var existing = document.getElementById('cf-incentive-bar');
    if (!existing) return;
    var html = buildIncentiveHTML(cartTotal);
    if (existing.innerHTML !== html) existing.innerHTML = html;
  }

  /* --- TRUST BADGES (image / svg-url / preset icon) --- */

  function badgeIconHTML(b) {
    if (b.image) {
      return '<img src="' + escapeHtml(b.image) + '" alt="" class="cf-trust-img">';
    }
    var paths = ICONS[b.icon] || ICONS.shield;
    return '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke-width="1.7">' + paths + '</svg>';
  }

  function createTrustBadges() {
    var el = document.createElement('div');
    el.className = 'cf-trust-row';
    el.id = 'cf-trust-row';
    el.setAttribute('data-cf-version', BADGE_VERSION);
    var html = '';
    TRUST_BADGES.forEach(function (b) {
      html +=
        '<div class="cf-trust-item">' +
          '<div class="cf-trust-icon" aria-hidden="true">' + badgeIconHTML(b) + '</div>' +
          '<span>' + escapeHtml(b.text) + '</span>' +
        '</div>';
    });
    el.innerHTML = html;
    return el;
  }

  function ensureTrustBadges(contents) {
    var existing = document.getElementById('cf-trust-row');

    if (!TRUST_BADGES.length) {           // all badges hidden/removed -> drop the row
      if (existing) existing.remove();
      return;
    }
    if (existing && existing.getAttribute('data-cf-version') === BADGE_VERSION) return;

    var newBadges = createTrustBadges();
    if (existing) { existing.replaceWith(newBadges); return; }

    var footer = document.querySelector('.kaching-cart__footer');
    if (!footer && contents) {
      var parent = contents.parentElement;
      while (parent && !footer) { footer = parent.querySelector('.kaching-cart__footer'); parent = parent.parentElement; }
    }
    if (footer) footer.before(newBadges);
    else if (contents) contents.appendChild(newBadges);
  }

  /* --- CART TITLE --- */

  function createCartTitle() {
    var el = document.createElement('div');
    el.className = 'cf-cart-title-row';
    el.id = 'cf-cart-title';
    el.innerHTML =
      '<svg class="cf-cart-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1c1c1c" stroke-width="1.5" aria-hidden="true">' +
        '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>' +
        '<line x1="3" y1="6" x2="21" y2="6"></line>' +
        '<path d="M16 10a4 4 0 0 1-8 0"></path>' +
      '</svg>' +
      '<span class="cf-cart-title-text">' + escapeHtml(CART_TITLE) + '</span>';
    return el;
  }

  function updateCartTitleText() {
    var t = document.querySelector('#cf-cart-title .cf-cart-title-text');
    if (t && t.textContent !== CART_TITLE) t.textContent = CART_TITLE;
  }

  function updateCartCount() {
    var title = document.getElementById('cf-cart-title');
    if (!title) return;
    var countEl = title.querySelector('.cf-cart-count');
    if (cachedItemCount > 0) {
      if (countEl) {
        if (countEl.textContent !== String(cachedItemCount)) countEl.textContent = String(cachedItemCount);
      } else {
        var span = document.createElement('span');
        span.className = 'cf-cart-count';
        span.textContent = cachedItemCount;
        title.appendChild(span);
      }
    } else if (countEl) {
      countEl.remove();
    }
  }

  /* --- FOOTER SAVINGS (write only if changed) --- */

  function updateFooterSavingsLabel() {
    var discountRows = document.querySelectorAll('.kaching-cart__cart-discounts');
    if (!discountRows.length) return;
    discountRows.forEach(function (row) {
      row.classList.add('cf-footer-savings-row');
      var title = row.querySelector('.kaching-cart__cart-discounts-title');
      var amount = row.querySelector('.kaching-cart__cart-discounts-amount');
      if (title && title.textContent !== FOOTER_SAVINGS_LABEL) title.textContent = FOOTER_SAVINGS_LABEL;
      if (amount) {
        var cleaned = cleanSavingsAmount(amount.textContent);
        if (cleaned && cleaned !== amount.textContent) {
          amount.textContent = cleaned;
          amount.setAttribute('aria-label', FOOTER_SAVINGS_LABEL + ': ' + cleaned);
        }
      }
    });
  }

  /* --- HIDE NATIVE LINE-ITEM SAVINGS --- */

  function hideNativeLineItemSavings() {
    var cartItems = document.querySelectorAll(
      '#kaching-cart .kaching-cart-item, #kaching-cart .kaching-cart-item-container, .kaching-cart .kaching-cart-item, .kaching-cart .kaching-cart-item-container'
    );
    if (!cartItems.length) return;
    cartItems.forEach(function (item) {
      item.querySelectorAll('div, span, p').forEach(function (el) {
        if (el.classList.contains('cf-hide-native-savings')) return;  // already hidden, no write
        if (el.closest('.kaching-cart__footer')) return;
        if (el.closest('.kaching-cart__badge') || el.classList.contains('kaching-cart__badge')) return;
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^du\s+sparer\b/i.test(text)) el.classList.add('cf-hide-native-savings');
      });
    });
  }

  /* --- MYSTERY BOX: mask Kaching's gift line item --- */

  function maskGiftLineItem() {
    var items = document.querySelectorAll('.kaching-auto-atc-gift-item');
    items.forEach(function (item) {
      var titleEl = item.querySelector('.kaching-auto-atc-gift-item__title');
      var img = item.querySelector('.kaching-auto-atc-gift-item__image');
      if (MYSTERY_MODE) {
        item.classList.add('cf-mystery-on');
        if (titleEl) {
          if (!titleEl.hasAttribute('data-cf-orig')) titleEl.setAttribute('data-cf-orig', titleEl.textContent);
          if (titleEl.textContent !== MYSTERY_LABEL) titleEl.textContent = MYSTERY_LABEL;
        }
        if (img && MYSTERY_IMAGE) {
          if (!img.hasAttribute('data-cf-orig')) img.setAttribute('data-cf-orig', img.getAttribute('src') || '');
          if (img.getAttribute('src') !== MYSTERY_IMAGE) img.setAttribute('src', MYSTERY_IMAGE);
          if (img.getAttribute('srcset')) img.setAttribute('srcset', '');
        }
      } else {
        item.classList.remove('cf-mystery-on');
        if (titleEl && titleEl.hasAttribute('data-cf-orig')) {
          titleEl.textContent = titleEl.getAttribute('data-cf-orig');
          titleEl.removeAttribute('data-cf-orig');
        }
        if (img && img.hasAttribute('data-cf-orig')) {
          img.setAttribute('src', img.getAttribute('data-cf-orig'));
          img.removeAttribute('data-cf-orig');
        }
      }
    });
  }

  /* ============================
     CORE INJECTION
     ============================ */

  function findContents() {
    return document.querySelector('.kaching-cart__contents') ||
           document.querySelector('#kaching-cart .kaching-cart__contents') ||
           document.querySelector('kaching-cart-drawer .kaching-cart__contents') ||
           document.querySelector('[class*="kaching"][class*="contents"]');
  }

  function injectTitle(contents) {
    if (document.getElementById('cf-cart-title')) return;
    var cart = contents.closest('#kaching-cart, .kaching-cart, kaching-cart') ||
               document.querySelector('#kaching-cart') || document.querySelector('.kaching-cart');
    var title = createCartTitle();
    if (cart) {
      var header = cart.querySelector('.kaching-cart__header') || cart.querySelector('[class*="kaching-cart__header"]');
      if (header) { header.insertBefore(title, header.firstChild); return; }
    }
    var firstModule = contents.querySelector('.kaching-cart__module');
    if (firstModule) firstModule.before(title);
    else contents.insertBefore(title, contents.firstChild);
  }

  function injectBar(contents, total) {
    if (document.getElementById('cf-incentive-bar')) return;
    var bar = createIncentiveBar(total);
    var titleInContents = contents.querySelector('#cf-cart-title');
    var firstModule = contents.querySelector('.kaching-cart__module');
    if (titleInContents) titleInContents.after(bar);
    else if (firstModule) firstModule.before(bar);
    else contents.insertBefore(bar, contents.firstChild);
  }

  function startPeriodicRefresh() {
    if (refreshInterval) return;
    refreshInterval = setInterval(function () {
      if (!document.getElementById('cf-incentive-bar')) {
        clearInterval(refreshInterval); refreshInterval = null; return;
      }
      var prevTotal = cachedCartTotal, prevGift = !!cachedGift;
      fetchCartTotal(function (total) {
        if (cachedItemCount <= 0) {        // cart emptied -> drop bar + count
          mutate(function () {
            var b = document.getElementById('cf-incentive-bar');
            if (b) b.remove();
            updateCartCount();
          });
          return;
        }
        if (total !== prevTotal || (!!cachedGift) !== prevGift) {
          mutate(function () {
            refreshIncentiveBar(total);
            updateCartCount();
            updateFooterSavingsLabel();
            hideNativeLineItemSavings();
            maskGiftLineItem();
          });
        }
      });
    }, 2500);
  }

  function injectElements() {
    refreshConfig();
    var contents = findContents();
    if (!contents) return;

    mutate(function () {
      cleanupLegacyElements();
      injectTitle(contents);
      updateCartTitleText();
      updateCartCount();
      ensureTrustBadges(contents);
      if (cachedItemCount > 0) {
        injectBar(contents, cachedCartTotal < 0 ? 0 : cachedCartTotal);
        refreshIncentiveBar(cachedCartTotal < 0 ? 0 : cachedCartTotal);
      } else {
        var b = document.getElementById('cf-incentive-bar');
        if (b) b.remove();
      }
      updateFooterSavingsLabel();
      hideNativeLineItemSavings();
      maskGiftLineItem();
    });

    startPeriodicRefresh();
    if (cachedCartTotal < 0) fetchCartTotal(function () { injectElements(); });
  }

  /* --- INIT --- */

  function init() {
    refreshConfig();
    fetchCartTotal(function () { log('prefetch', cachedCartTotal, cachedItemCount); });

    var mutationTimer = null;
    observer = new MutationObserver(function () {
      if (mutationTimer) return;
      mutationTimer = setTimeout(function () { mutationTimer = null; injectElements(); }, 120);
    });
    observer.observe(document.body, OBS_OPTS);

    // Theme-editor live reactivity: re-read config and update IN PLACE.
    // Debounced, and no destructive teardown (removing/re-adding elements on
    // every editor event made the widget "dance" in the editor preview).
    var editorTimer = null;
    function onEditorChange() {
      if (editorTimer) clearTimeout(editorTimer);
      editorTimer = setTimeout(function () {
        editorTimer = null;
        lastCfgRaw = null;
        refreshConfig();
        injectElements();
      }, 200);
    }
    ['shopify:section:load', 'shopify:section:unload'].forEach(function (ev) {
      document.addEventListener(ev, onEditorChange);
    });

    injectElements();
    [100, 500, 1500, 3000].forEach(function (t) { setTimeout(injectElements, t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
